"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = formatGetUrl;

var _typeof2 = _interopRequireDefault(require("@babel/runtime/helpers/typeof"));

function formatGetUrl(url, data) {
  if (data && Object.keys(data).length > 0) {
    var params = Object.keys(data).map(function (key) {
      return encodeURIData(data, key);
    }).join('&').replace(/%20/g, '+');
    return url + '?' + params;
  } else {
    return url;
  }
}

function encodeURIData(data, key) {
  if (Array.isArray(data[key]) && (0, _typeof2["default"])(data[key][0]) !== 'object') {
    var array = data[key].map(function (element) {
      return encodeURIComponent(key) + '[]=' + encodeURIComponent(element);
    });
    return array.join('&');
  }

  if ((0, _typeof2["default"])(data[key]) === 'object' || Array.isArray(data[key]) && (0, _typeof2["default"])(data[key][0]) === 'object') {
    return encodeURIComponent(key) + '=' + JSON.stringify(data[key]);
  }

  return encodeURIComponent(key) + '=' + encodeURIComponent(data[key]);
}